import {
    createContext,
    useContext,
    useState,
    useEffect,
    ReactNode,
} from "react";

import { apiPaths } from "../utils/apiUtils";
import { OAuthGetUserDataApi } from "../api/application"
import { useReviewContext } from "./ReviewContext";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const storedUser = sessionStorage.getItem("user");
    const { setReviewerProfileData } = useReviewContext();

    useEffect(() => {
        validateUserSession();
    }, [storedUser]);


    const validateUserSession = async () => {
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            const OAuthResponse = await OAuthGetUserDataApi();

            if (OAuthResponse?.status === 200) {
                const OAuthData = await OAuthResponse.data;
                if (parsedUser?.userId != OAuthData?.name) {
                    fetchAndUpdateUserDetails(OAuthResponse);
                }
            } else {
                console.log("Clearing the session.")
                sessionStorage.clear();
            }
        }
    };

    const AuthenticateUser = async () => {
        const OAuthResponse = await OAuthGetUserDataApi();
        if (OAuthResponse?.status === 200) {
            fetchAndUpdateUserDetails(OAuthResponse);
            return true;
        } else {
            return false;
        }
    };

    const fetchAndUpdateUserDetails = async (OAuthResponse) => {
        const OAuthData = await OAuthResponse.data;
        console.log("OAuthData: ", OAuthData);
        const userId = OAuthData?.name;
        const name = OAuthData?.attributes?.name;
        const email = OAuthData?.attributes?.email;
        setReviewerProfileData({ name: name, email: email });
        sessionStorage.setItem("user", JSON.stringify({ userId, name, email }));
    };

    const OAuthLogin = () => {
        window.location.href = `${window.location.origin}${apiPaths.Oauth}/authorize`;
    };

    const OAuthLogout = () => {
        sessionStorage.removeItem("user");
        window.location.href = `${window.location.origin}${apiPaths.Oauth}/logout`;
    };

    return (
        <AuthContext.Provider
            value={{
                OAuthLogin,
                OAuthLogout,
                AuthenticateUser,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};